import * as React from 'react';
import classNames from 'classnames';

import { ReactComponent as LogoDark } from '../../common/imgs/Logo.svg';
import { ReactComponent as LogoIconOnly } from '../../common/imgs/LogoIconOnly.svg';
import { ReactComponent as LogoLight } from '../../common/imgs/LogoLight.svg';

export interface LogoProps {
  id?: string;
  type?: 'dark' | 'icon' | 'light';
  className?: string;
}

const Logo: React.FC<LogoProps> = (props: LogoProps) => {
  const { id, type = 'dark', className } = props;

  const logoClassNames = classNames(className);

  switch (type) {
    case 'light':
      return <LogoLight id={id} className={logoClassNames} />;
    case 'dark':
      return <LogoDark id={id} className={logoClassNames} />;
    case 'icon':
      return <LogoIconOnly id={id} className={logoClassNames} />;
    default:
      return null;
  }
};

export default Logo;
